import { useState } from "react";

import { getAnalytics, logEvent } from "firebase/analytics";

import { IosShareRounded } from "@mui/icons-material";

import { LABEL_DOMAIN } from "../constants/labels";
import { eventPreviewShared } from "./eventHelper";
import { shareContent, SHARE_FAILURE_MESSAGE } from '../utils/shareContent';
import StatusToast from './StatusToast';

const PreviewShareButton = ({ buttonStyle, iconStyle, className, trackId, messageIndex, showLabel }) => {
    const analytics = getAnalytics();

    const [copiedToastGeneration, setCopiedToastGeneration] = useState(0);
    const [shareError, setShareError] = useState('');

    const sharePreview = async () => {
        const url = `https://${LABEL_DOMAIN}/preview/${encodeURIComponent(trackId)}/${encodeURIComponent(messageIndex)}`;
        setShareError('');
        setCopiedToastGeneration(0);
        logEvent(analytics, "share_preview_card");
        try {
            const result = await shareContent({ url });
            if (result === 'cancelled') return;
            if (result === 'copied') {
                setCopiedToastGeneration((generation) => generation + 1);
            }
            eventPreviewShared(`${trackId}_${messageIndex}`);
        } catch (_) {
            setShareError(SHARE_FAILURE_MESSAGE);
        }
    }

    return (
        <>
            <button type='button' className={className} style={buttonStyle} onClick={sharePreview} aria-label='Share highlight'>
                <div>
                    <IosShareRounded style={iconStyle} aria-hidden='true' />
                    {showLabel && <span style={{ verticalAlign: 'middle', paddingLeft: '10px', fontWeight: '500', fontSize: '14px' }}>
                        share
                    </span>}
                </div>
            </button>
            <StatusToast
                open={copiedToastGeneration > 0}
                instanceKey={copiedToastGeneration}
                message='Copied to clipboard'
                onClose={() => setCopiedToastGeneration(0)}
            />
            <StatusToast tone='error' open={Boolean(shareError)} message={shareError} onClose={() => setShareError('')} />
        </>
    );
};

export default PreviewShareButton;
